import React from 'react'
import { Alert, Modal, ModalBody } from 'reactstrap'

const ConfirmationModal = ({ onCancelCleaning, isOpenCancelCleaning, toggleCancelCleaning }) => {
  return (
    <Modal size={`md`} centered isOpen={isOpenCancelCleaning} toggle={toggleCancelCleaning}>
      <ModalBody>
        <div className="confimation-close">
          <i className="fa-regular fa-circle-xmark" onClick={toggleCancelCleaning} style={{ cursor: 'pointer' }} />
        </div>
        <div className="m-3">
          <div className="form-header">
            <p className="modal_highlight_text text-center mb-3">Do you want to charge a cancellation fee?</p>
            <Alert color="warning">If you cancel the cleaning within 2 hours of the scheduled time, a cancellation fee will be applied.</Alert>
          </div>
          <div className="multi_btn_div">
            <button type="button" className="btn btn-success common-field-btn w-100 btn-small" onClick={() => onCancelCleaning(true)}>
              Yes
            </button>
            <button type="button" className="btn common-outline-btn btn-small w-100" onClick={() => onCancelCleaning(false)}>
              No
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}
export default ConfirmationModal
